'use client'

import { useState } from 'react'
import { LuMenu, LuX } from 'react-icons/lu'
import { ButtonGroup, Drawer, Portal, Text } from '@chakra-ui/react'
import { ProductCategory } from '@leid/api-products'

import MobileCategoryMenuItem from './MobileCategoryMenuItem'

type Props = {
  title: string
  categories: ProductCategory[]
}

const MobileMenuClientPart = ({ title, categories }: Props): JSX.Element => {
  const [isOpened, setIsOpened] = useState(false)

  const handleOpen = () => {
    setIsOpened(true)
  }

  const handleClose = () => {
    setIsOpened(false)
  }

  return (
    <Drawer.Root size={'full'} placement={'start'} open={isOpened}>
      <Drawer.Trigger
        onClick={handleOpen}
        style={{ marginRight: '12px' }}
        color="green.a200"
        fontSize="sm"
        fontWeight={600}
      >
        <Text>
          <LuMenu size={32} />
        </Text>
      </Drawer.Trigger>

      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content>
            <Drawer.Header>
              <Drawer.Title>{title}</Drawer.Title>

              <ButtonGroup>
                <button style={{ cursor: 'pointer' }} onClick={handleClose}>
                  <LuX size={32} />
                </button>
              </ButtonGroup>
            </Drawer.Header>
            <Drawer.Body>
              {categories.map((s) => (
                <MobileCategoryMenuItem key={s.id} category={s} allCategories={categories} closeAll={handleClose} />
              ))}
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  )
}

export default MobileMenuClientPart
